import styled from 'styled-components';

import { headerVariables } from '../Header/HeaderStyle';

import {
  breakpoints,
  colors,
  fontFamily,
  functions,
  zIndex,
} from '../../ui/variables';

const main = {
  height: {
    iphone: 168,
    ipadLandscape: 112,
  },
};

const headerTools = {
  gridGap: {
    iphone: 8,
    iphone8: 16,
  },
};

const navigationLink = {
  size: {
    iphone: 48,
  },
};

const selectReportArea = {
  flexBasis: {
    ipadLandscape: 0.36,
    hd: 0.44,
  },
};

const editNavigationArea = {
  flexBasis: {
    ipadLandscape: 180,
    hd: 232,
  },
};

const approveReviewArea = {
  flexBasis: {
    ipadLandscape: `calc(100% - ${
      selectReportArea.flexBasis.ipadLandscape * 100
    }% - ${editNavigationArea.flexBasis.ipadLandscape}px)`,
    hd: `calc(100% - ${selectReportArea.flexBasis.hd * 100}% - ${
      editNavigationArea.flexBasis.hd
    }px)`,
  },
};

export const singleReportHeaderVariables = {
  main,
};

export const SingleReportHeaderStyle = styled.div`
  ${zIndex.sky};
  background-color: ${functions.flattened(
    colors.veryDarkGrayishBlue,
    colors.white,
    0.9
  )};
  color: ${colors.mostlyWhite};
  left: 0;
  padding: 0 20px 24px;
  position: fixed;
  top: ${headerVariables.main.height.iphone}px;
  width: 100vw;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: 0 40px 24px 20px;
  }

  .back-link {
    ${fontFamily.sourceSansPro.regular};
    display: inline-block;
    font-size: 14px;
    line-height: 16px;
    padding: 12px 0 12px 32px;
    position: relative;

    .icon {
      display: block;
      height: 20px;
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;

      svg {
        display: block;
        fill: ${colors.mostlyWhite};
        height: auto;
        width: 100%;
      }
    }
  }

  .header-tools {
    column-gap: ${headerTools.gridGap.iphone}px;
    display: grid;
    grid-template-areas: 'select nav' 'approve approve';
    grid-template-columns:
      calc(
        100% -
          (${2 * navigationLink.size.iphone + 2 * headerTools.gridGap.iphone}px)
      )
      104px;
    grid-template-rows: auto;
    row-gap: ${headerTools.gridGap.iphone}px;

    @media (min-width: ${breakpoints.iphone8.width}px) {
      column-gap: ${headerTools.gridGap.iphone8}px;
      grid-template-columns:
        calc(
          100% -
            (
              ${2 * navigationLink.size.iphone +
              2 * headerTools.gridGap.iphone8}px
            )
        )
        112px;
      row-gap: ${headerTools.gridGap.iphone8}px;
    }

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      width: 100%;
    }

    .select-report-area {
      grid-area: select;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        flex-basis: ${selectReportArea.flexBasis.ipadLandscape * 100}%;
        max-width: 564px;
      }

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: ${selectReportArea.flexBasis.hd * 100}%;
      }
    }

    .approve-review-area {
      display: flex;
      grid-area: approve;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: flex;
        flex-basis: ${approveReviewArea.flexBasis.ipadLandscape};
        flex-wrap: wrap;
        justify-content: center;
        max-width: 416px;
        position: relative;
      }

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: ${approveReviewArea.flexBasis.hd};
      }

      .agree-with-results-ai {
        display: none;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.mostlyWhite};
          display: block;
          font-size: 14px;
          left: 50%;
          line-height: 16px;
          margin-bottom: 12px;
          position: absolute;
          text-align: center;
          top: -12px;
          transform: translate(-50%, -100%);
          width: 100%;
        }
      }

      .approve-results-button {
        display: inline-block;
        flex-basis: 50%;
        flex-grow: 1;
        margin-right: 4px;
        width: 50%;

        @media (min-width: ${breakpoints.iphone8.width}px) {
          margin-right: 8px;
        }

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 200px;
        }
      }

      .request-review-button {
        display: inline-block;
        flex-basis: 50%;
        flex-grow: 1;
        margin-left: 4px;
        width: 50%;

        @media (min-width: ${breakpoints.iphone8.width}px) {
          margin-left: 8px;
        }

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 200px;
        }
      }
    }

    .edit-and-navigation-area {
      grid-area: nav;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: flex;
        flex-basis: ${editNavigationArea.flexBasis.ipadLandscape}px;
        justify-content: flex-end;
        max-width: 368px;
      }

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: ${editNavigationArea.flexBasis.hd}px;
      }

      .edit-button-wrapper {
        display: none;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          /* display: block; */
          margin-right: 18px;
        }
      }

      .navigation-wrapper {
        display: flex;

        .navigation-link {
          max-width: 48px;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: initial;
          }

          &.last-navigation-link {
            margin-right: 4px;

            @media (min-width: ${breakpoints.iphone8.width}px) {
              margin-right: 8px;
            }
          }

          &.next-navigation-link {
            margin-left: 4px;

            @media (min-width: ${breakpoints.iphone8.width}px) {
              margin-left: 8px;
            }
          }
        }
      }
    }
  }

  .confirm-report-modal-container {
    padding: 24px 48px 44px 40px;

    .report-modal-title,
    .report-modal-question,
    .report-modal-description,
    .report-modal-actions {
      max-width: 404px;
    }

    .report-modal-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 12px;
    }

    .report-modal-question {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 12px;
    }

    .report-modal-description {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 20px;
    }

    .report-modal-actions {
      display: flex;
      flex-wrap: nowrap;
      width: 100%;

      .modal-action-wrapper {
        flex-basis: calc(50% - 16px);

        &:first-child {
          margin-right: 32px;
        }
      }
    }
  }
`;
